var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{staticClass:"line",attrs:{"fill":"currentColor","d":"M7.512 23.071L23.068 7.515l1.415 1.414L8.926 24.485z"}}),_c('path',{staticClass:"line",attrs:{"fill":"currentColor","d":"M8.929 7.512l15.556 15.556-1.414 1.415L7.515 8.926z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }